<template>
  <!-- 订舱 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>精选运价</el-breadcrumb-item>
        <el-breadcrumb-item>查询结果</el-breadcrumb-item>
        <el-breadcrumb-item class="bread">订舱</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 模版 -->
      <div class="template">
        <div class="left">
          <div class="shiyopng">
            使用订舱模板
            <span class="wode">我的模板</span>
          </div>
          <div>使用订舱模板，快捷填写一键下单</div>
        </div>
        <div class="right">
          <div @click="getTemplate">
            选择模板
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <!-- 订舱信息 -->
      <div class="info">
        <div class="shang">
          <div class="logo">
            <img :src="canshu.shipping_companyLogo" alt="" />
          </div>
          <div class="qiyun">
            <div class="date"><span class="jiacu">ETD:</span>{{ canshu.etd }}</div>
            <div class="address">{{ canshu.pol_name }}</div>
          </div>
          <div class="dao">
            <div class="tian">{{ canshu.shipping_date }}天</div>
            <img src="@/assets/images/Group 113@2x.png" alt="" />
            <div class="zhida">
              {{ canshu.is_transit == 1 ? "中转" : "直达" }}
            </div>
          </div>
          <div class="qiyun">
            <div class="date"><span class="jiacu">ETA:</span>{{ canshu.eta }}</div>
            <div class="address">{{ canshu.pod_name }}</div>
          </div>
        </div>
        <div class="xia xiaxia">
          <div class="youbian">供应商编号：{{canshu.supplier_infoSn}}</div>
          <div class="youbian">舱位号：{{canshu.order_sn}} <span class="copy" @click="getCopy(canshu.order_sn)">复制</span></div>
          <div class="youbian">航线：{{ canshu.routeCd }}</div>
          <div>船名航次：{{canshu.vessel}}/{{canshu.voyage}}</div>
        </div>
        <div class="zhong">
          <div class="kuan">运输条款：{{ canshu.transportation_terms }}</div>
          <div class="kuan">箱源：{{ canshu.box_source }}</div>
          <div>
            提单类型：{{ canshu.bill_of_lading_type_desc }}
          </div>
          <div>目的港免堆/免用箱：{{ canshu.freetime_desc }}</div>
        </div>
        <div class="zhong">
          <div>截单时间：{{ canshu.cutoff_bill_of_lading_time }}</div>
          <div>进港/开港时间：{{ canshu.cyOpen }}</div>
          <div>截港时间：{{ canshu.cutoff_enter_the_port_time }}</div>
          <div>
            运价有效期：{{ canshu.freight_rate_state_time }} -
            {{ canshu.freight_rate_end_time }}
          </div>
        </div>
        <div class="xia xiaxia">
          <div class="kuan">
            亏舱费：
            <el-popover placement="bottom" width="200" trigger="click">
              <p v-for="(it,idx) in canshu.basic_freight" :key="idx">
                {{ it.box_type }}：<span>{{ it.dead_freight }}</span>
              </p>
              <div class="cilick" slot="reference">点击查看</div>
            </el-popover>
          </div>
          <div class="kuan">
            超重限制：
            <el-popover placement="bottom" trigger="click">
              <el-table :data="canshu.basic_freight">
                <el-table-column property="box_type" label="箱型"></el-table-column>
                <el-table-column property="overweight" label="限重">
                  <template slot-scope="scope">
                      {{scope.row.overweight==0?'不限重':'限重'}}
                  </template>
                </el-table-column>
                <el-table-column  width="380" property="weight_limit" label="限重规则">
                    <template slot-scope="scope">
                        <!-- {{scope.row.weight_limit==''?scope.row.weight_limit:'--'}} -->
                        <!-- {{scope.row.weight_limit}} -->
                        <div v-if="scope.row.weight_limit==''">--</div>
                        <div v-else>
                          <el-table
                          border
                          style="width: 500px"
                            :data="scope.row.weight_limit">
                            <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column property="overweight_fees" label="超重费用">
                                <template slot-scope="scopeItem">
                                  USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                </template>
                            </el-table-column>
                          </el-table>
                        </div>
                    </template>
                </el-table-column>
              </el-table>
              <div class="cilick" slot="reference">点击查看</div>
            </el-popover>
          </div>
          <div class="kuan">
            品名要求：
            <el-popover placement="bottom" width="200" trigger="click">
              <p v-for="(it,idx) in canshu.product_name" :key="idx">
                {{ it }}
              </p>
              <div class="cilick" slot="reference">点击查看</div>
            </el-popover>
          </div>
        </div>
      </div>
        <!-- 客服代码 -->
        <div class="customs">
            <div class="title">客服代码</div>
            <div class="form-tit"><span>*</span>客服</div>
            <div class="input">
              <div
                class="yi"
              >
              <el-select disabled v-model="form.sales_code" placeholder="请选择">
                <el-option
                  v-for="item in baseEmailsList"
                  :key="item.id"
                  :label="item.nickname+'-'+item.phone"
                  :value="item.sales_code"
                >
                </el-option>
              </el-select>
              </div>
            </div>
        </div>
        <!-- 海关编号 -->
        <div class="customs">
          <div class="title">HS(海关编号)</div>
          <div class="form-tit"><span>*</span>HS(海关编号：仅限六位数字)</div>
          <div class="input">
            <div
              class="yi"
              v-for="(item, index) in inputList"
              :key="index"
              :class="(index + 1) % 4 == 0 ? 'yi2' : 'yi'"
            >
              <el-input @blur="hsBlus" v-model="item.text" placeholder="请输入"></el-input>
              <i @click="removeRow(index)" class="el-icon-delete"></i>
            </div>
          </div>
          <div class="add" @click="addRow">
            <i class="el-icon-circle-plus-outline"></i>
            <div>新增HS</div>
          </div>
        </div>

        <!-- 箱型 -->
        <!-- {{canshu.basic_freight}} -->
        <div class="boxType">
          <!-- <div class="title">
            选择箱型箱量
          </div> -->
          <div class="title">
            选择箱型箱量
            <el-popover placement="bottom" trigger="click">
              <el-table :data="canshu.basic_freight">
                <el-table-column property="box_type" label="箱型"></el-table-column>
                <el-table-column property="overweight" label="限重">
                  <template slot-scope="scope">
                      {{scope.row.overweight==0?'不限重':'限重'}}
                  </template>
                </el-table-column>
                <el-table-column  width="380" property="weight_limit" label="限重规则">
                    <template slot-scope="scope">
                        <!-- {{scope.row.weight_limit==''?scope.row.weight_limit:'--'}} -->
                        <!-- {{scope.row.weight_limit}} -->
                        <div v-if="scope.row.weight_limit==''">--</div>
                        <div v-else>
                          <el-table
                          border
                          style="width: 500px"
                            :data="scope.row.weight_limit">
                            <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column property="overweight_fees" label="超重费用">
                                <template slot-scope="scopeItem">
                                  USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                </template>
                            </el-table-column>
                          </el-table>
                        </div>
                    </template>
                </el-table-column>
              </el-table>
              <div class="cilick" slot="reference">超重限制</div>
            </el-popover>
          </div>
          <div class="box-c" v-for="(item, index) in boxList" :key="index">
            <div class="box-con">
                <el-select @change="changeBox(index)" class="ronmg" v-model="item.box_type" placeholder="请选择">
                  <el-option
                  v-for="(it,index) in canshu.basic_freight"
                  :key="index"
                  :label="it.box_type"
                  :value="it.box_type">
                </el-option>
                </el-select>
                <div class="line"></div>
                <div class="nei ronmg">
                    <span class="zhongKgs">货重(kgs)</span>
                    <!-- 验证单箱重量，超过最大货重不允许下单 -->
                    <el-input  v-model="item.weight" min='0' type="number" @change="changeBoxWeight(index)" placeholder="请输入"></el-input>
                </div>
                <div class="line"></div>
                <div  class="nei ronmg">
                    <span>USD</span>
                    <el-input disabled v-model="item.price" placeholder="价格"></el-input>
                </div>
                <div class="line"></div>
                <div  class="nei ronmg">
                    <span>CNY</span>
                    <el-input disabled v-model="item.dead_freight" placeholder="亏舱费"></el-input>
                </div>
            </div>
            <i 
            class="el-icon-delete"
            @click="removeBox(index)" 
            ></i>
          </div>

          <div class="add" @click="addBox">
            <i class="el-icon-circle-plus-outline"></i>
            <div>新增箱型</div>
          </div>
        </div>

        <!-- 货物信息 -->
        <div class="CargoInformation">
          <div class="title">货物信息</div>

          <div class="info-shang">
            <div>
              <div class="word"><span>*</span>包装单位</div>
              <el-select v-model="form.packing_unit" placeholder="请选择">
                <el-option
                  v-for="item in packingList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <div class="word"><span>*</span>件数</div>
              <el-input
                min='0' type="number"
                @blur="onBlur"
                v-model="form.quantity"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>总货重(kgs)</div>
              <el-input
                readonly
                v-model="form.totle_weight"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>体积(cbm)</div>
              <el-input
                min='0' type="number"
                @blur="onBlur"
                v-model="form.totle_volume"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>

          <div class="info-shang">
            <div>
              <div class="word"><span>*</span>唛头</div>
              <el-input
                type="textarea"
                v-model="form.shipping_mark"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>货物描述</div>
              <el-input
                type="textarea"
                v-model="form.describe"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
        </div>

        <!-- 收发通 -->
        <div class="CargoInformation shoufat">
          <div class="title">
            收发通
            <el-button type="text" @click="getShoudatong">常用收发通</el-button>
          </div>
          <div class="info-shang info-shoufat">
            <div>
              <div class="word"><span>*</span>发货人</div>
              <el-input
                type="textarea"
                v-model="form.shipper_mawb"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>收货人</div>
              <el-input
                type="textarea"
                v-model="form.consignee_mawb"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>通知人</div>
              <el-input
                type="textarea"
                v-model="form.notifier_mawb"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
        </div>

        <!-- 订舱联系人 -->
        <div class="CargoInformation phone-info">
          <div class="title">
            订舱联系人
            <el-button type="text"  @click="getLianxiren">常用订舱联系人</el-button>
          </div>

          <div class="info-shang">
            <div class="yi1">
              <div class="word"><span>*</span>订舱联系人</div>
              <el-input v-model="form.linkman" placeholder="请输入"></el-input>
              <!-- <el-select v-model="form.linkman" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select> -->
            </div>
            <div class="yi1">
              <div class="word"><span>*</span>联系人电话</div>
              <el-input
                @blur="validDianhua"
                v-model="form.linkman_phone"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div
              class="yi"
              v-for="(item, index) in emailList"
              :key="index"
              :class="(index + 3) % 4 == 0 ? 'yi2' : 'yi'"
            >
              <div class="word"><span>*</span>联系人邮箱</div>
              <div class="ipt_del">
                <el-input @blur="validEmsil" v-model="item.email" placeholder="请输入"></el-input>
                <div @click="removeEmail(index)" class="delete">删除</div>
              </div>
            </div>
          </div>

          <div class="add" @click="addEmail">
            <i class="el-icon-circle-plus-outline"></i>
            <div>新增联系人邮箱</div>
          </div>

          <!-- 上传 -->

          <div class="update">
            <div class="title">上传附件</div>
            <div class="shangchuan">
              <div class="word">上传附件（最多可上传10份附件）</div>
              <div class="btn">
                <!-- action  上传地址 -->
                <div>
                  <el-upload
                    class="upload-demo"
                    action="https://serve.dhcang.com/api/upload/file"
                    :on-success="fujianSuccess"
                    multiple
                    :headers="headers"
                    :show-file-list="false"
                  >
                    <el-button class="sc_btn" size="small" type="primary"
                      >上传附件</el-button
                    >
                  </el-upload>
                  <div
                    class="updateList"
                    v-for="(item, index) in fujianFileList"
                    :key="index"
                  >
                    <i class="el-icon-success"></i>
                    <div class="name">{{ item.file_name }}</div>
                    <el-button class="el-butnm del" @click="download(item)" type="text">下载</el-button>
                    <el-button
                      @click="fujianRemove(index)"
                      class="el-butnm"
                      type="text"
                      >删除</el-button
                    >
                  </div>
                </div>
                <!-- 上传委托书 -->
                <!-- <div>
                  <el-upload
                    class="upload-demo"
                    action="https://serve.dhcang.com/api/upload/file"
                    multiple
                    :on-success="weituoshuSuccess"
                    :headers="headers"
                    :show-file-list="false"
                  >
                    <el-button class="sc_btn" size="small" type="primary"
                      >上传委托书</el-button
                    >
                  </el-upload>
                  <div
                    class="updateList"
                    v-for="(item, index) in weituoshuFileList"
                    :key="index"
                  >
                    <i class="el-icon-success"></i>
                    <div class="name">{{ item.file_name }}</div>
                    <el-button class="el-butnm del" @click="download(item)" type="text">下载</el-button>
                    <el-button
                      @click="weituoshuRemove(index)"
                      class="el-butnm"
                      type="text"
                      >删除</el-button
                    >
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="info-shang info_phone">
            <div class="title">订单备注</div>
            <div>
              <div class="word">备注信息</div>
              <el-input
                type="textarea"
                v-model="form.order_remarks"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
        </div>

    </div>
    
    <div class="fukuan">
        <div class="fk-content typeArea">
          <div class="fk-left">
            <div class="yi">
              <span class="spn">付款方式：</span>
              <el-radio v-model="form.pay_method" label="1">预付</el-radio>
              <el-radio v-model="form.pay_method" label="2">到付</el-radio>
            </div>
            <div class="er">
              提交本页订舱信息即代表您同意<span  @click="xieyi">《服务协议》</span>相关条款进行订舱
            </div>
            <div class="san">
              提交订舱后将从余额内冻结亏仓费
            </div>
          </div>
          <div class="fk-right">
            <!-- <span class="zong">USD {{boxPrice + otherPrice}} + CNY {{boxPriceDead+boxPriceOver}}</span> -->
            <div class="zongqian">
              <span class="zong">USD {{boxPrice + haiyunPrice +boxPriceOver + linefeeTotal}} + CNY {{boxPriceDead }}</span>
              <span class="qianmingcheng"> 基本海运费 + 海运附加费 {{chaozhong==1?'+ 箱型超重费':''}}{{linefeeTotal>0?'+ 服务费':''}}</span>
            </div>
            <el-button @click="table = true" class="mingxi">价格明细</el-button>
            <el-button class="tijiao" @click="submit">提交订舱</el-button>
          </div>
        </div>
      </div>
    <Bottom />

    <!-- 模版弹窗 -->
    <el-dialog title="我的模版" :visible.sync="dialogTableVisible">
      <el-table ref="table" :data="gridData" @expand-change="expandChange">
        <el-table-column width="180" label="模版编号">
          <template slot-scope="scope">
            <el-radio v-model="mobanRadio" :label="scope.row.id"></el-radio>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="180"
          property="id"
          
        ></el-table-column> -->
        <el-table-column
          property="template_name"
          label="模版名称"
        ></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- 展开内容 -->
            <span>展开 {{ props.row.template_name }}</span>

            <div class="modelDetail">
                <!-- 海关编号 -->
                <div class="detail">
                  <div class="de-tit">HS(海关编号)</div>
                  <div class="de-con">
                    <div
                      v-for="(item,index) in templateForm.hs" 
                      :key="index"
                      class="conyi"
                      :class=" (index+1) % 4 == 0 ? 'coner' : ''" 
                    >
                      <div>{{item}}</div>
                    </div>
                  </div>
                </div>
                <!-- 箱型 -->
                <div class="detail">
                  <div class="de-tit">箱型</div>
                  <div class="de-con">
                    <div
                      v-for="(item,index) in templateForm.boxtype" 
                      :key="index"
                      class="conyi"
                      :class=" (index+1) % 4 == 0 ? 'coner' : ''" 
                    >
                      <div>箱型：{{item.box_type}}--箱重：{{item.weight || '0'}}</div>
                    </div>
                  </div>
                </div>
                <!-- 包装单位 -->
                <div class="detail">
                  <div class="de-con de-coner">
                    <div>
                      <div class="de-tit">包装单位</div>
                      <div class="conyi">
                        <div>{{templateForm.packing_unit}}</div>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">件数</div>
                      <div class="conyi">
                        <div>{{templateForm.quantity}}</div>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">总重量(kgs)</div>
                      <div class="conyi">
                        <div>{{templateForm.totle_weight}}</div>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">体积(cbm)</div>
                      <div class="conyi">
                        <div>{{templateForm.totle_volume}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 货物描述 -->
                <div class="detail">
                  <div class="de-con de-coner de-consan">
                    <div>
                      <div class="de-tit">唛头</div>
                      <div class="conyi">
                        <p>{{templateForm.shipping_mark}}</p>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">货物描述</div>
                      <div class="conyi">
                        <p>
                          {{templateForm.describe}}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 发货人 -->
                <div class="detail">
                  <div class="de-con de-coner de-consan de-consi">
                    <div>
                      <div class="de-tit">发货人</div>
                      <div class="conyi">
                        <p>
                          {{templateForm.shipper}}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">收货人</div>
                      <div class="conyi">
                        <p>
                          {{templateForm.consignee}}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">通知人</div>
                      <div class="conyi">
                        <p>
                          {{templateForm.notifier}}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 订舱联系人 -->
                <div class="detail">
                  <div class="de-con">
                    <div>
                      <div class="de-tit">订舱联系人</div>
                      <div class="conyi">
                        <div>{{templateForm.linkman}}</div>
                      </div>
                    </div>
                    <div>
                      <div class="de-tit">联系人电话</div>
                      <div class="conyi">
                        <div>{{templateForm.linkman_phone}}</div>
                      </div>
                    </div>
                    <div 
                        v-for="(item,index) in templateForm.email" 
                        :key="index">
                      <div class="de-tit">联系人邮箱</div>
                      <div
                        class="conyi"
                        :class=" (index+3) % 4 == 0  ? 'coner' : ''" 
                      >
                        <div>{{item}}</div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <!-- 附件 -->
                <div class="detail">
                  <div class="de-con">
                    <div v-for="(item,index) in templateForm.files" :key="index">
                      <!-- <div class="de-tit">{{item.type==1?'附件':'托运书'}}</div> -->
                      <div class="de-tit">附件</div>
                      <div class="conyi">
                        <div class="con-up">
                          <i class="el-icon-success"></i>
                          <span class="name">{{item.file_name}}</span>
                          <el-button class="el-butnm del" @click="download(item)" type="text">下载</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 货物描述 -->
                <div class="detail">
                  <div class="de-con de-consan de-conwu">
                    <div>
                      <div class="de-tit">备注信息</div>
                      <div class="conyi">
                        <p>{{templateForm.remarks}}</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">返回</el-button>
        <el-button type="primary" @click="useTemplate"
          >使用模版</el-button
        >
      </div>
    </el-dialog>

    <!-- 常用收发通 -->
    <el-dialog title="常用收发通" :visible.sync="dialogShoufatong">
      <el-table ref="tableShoufatong" :data="gridDataSoufatong">
        <el-table-column width="180" label="编号">
          <template slot-scope="scope">
            <el-radio v-model="soufatongRadio" :label="scope.row.id+1"></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          property="shipper"
          label="收货人"
        ></el-table-column>
        <el-table-column
          property="consignee"
          label="发货人"
        ></el-table-column>
        <el-table-column
          property="notifier"
          label="通知人"
        ></el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShoufatong = false">返回</el-button>
        <el-button type="primary"  :disabled="soufatongRadio==''"  @click="useShoufatong "
          >使用</el-button
        >
      </div>
    </el-dialog>
    <!-- 常用联系人 -->
    <el-dialog title="常用订舱联系人" :visible.sync="dialogLianxiren">
      <el-table ref="tableLianxiren" :data="gridDataLianxiren">
        <el-table-column width="180" label="编号">
          <template slot-scope="scope">
            <el-radio v-model="lianxirenRadio" :label="scope.row.id+1"></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          property="linkman"
          label="订舱联系人"
        ></el-table-column>
        <el-table-column
          property="linkman_phone"
          label="订舱联系人电话"
        ></el-table-column>
        <el-table-column
          property="linkman_email"
          label="订舱联系人邮箱"
        >
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.linkman_email" :key="index">
              {{item}}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogLianxiren = false">返回</el-button>
        <el-button type="primary" :disabled="lianxirenRadio==''" @click="useLianxiren"
          >使用</el-button
        >
      </div>
    </el-dialog>
      <!-- 价格明细抽屉 -->
      <el-drawer
        title="价格明细"
        :visible.sync="table"
        direction="rtl"
        :with-header="false"
        size="50%">
        <div class="drawer-title">
          <div class="word">
            价格明细<span>实际费用以账单为准</span>
          </div>
          <div>
            <i @click="table = false" class="el-icon-close"></i>
          </div>
        </div>
        <div class="tab-det">
          <div class="tab-tit">基本海运费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td v-for="(item,ind) in canshu.basic_freight" :key="ind">
                  {{item.box_type}}
              </td>
              <td>单位</td>
            </tr>
            <tr class="tbody">
              <td  class="first">基本海运费</td>
              <td v-for="(item,ind) in canshu.basic_freight" :key="ind">
                价格：USD {{item.price}}<br>
                {{item.overweight==1?'超重费：USD '+ boxPriceOver  : ''}}
              </td>
              <td>箱</td>
            </tr>
          </table>
          <div class="tab-tit renminbi">海运附加费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>费用类型</td>
              <td colspan="2">收费单位</td>
            </tr>
            <tr class="tbody" v-for="(item,index) in priceList" :key="index">
              <td  class="first">{{item.surcharge_title}}</td>
              <td>{{item.cost_unit == 1 ? '箱' : '票' }}</td>
              <!-- <td>{{item.fee}}</td> -->
              <td  colspan="2" v-if="item.cost_unit == 2">USD {{item.vote_cost}}</td>
              <td class="xiaotab" v-if="item.cost_unit == 1">

                <table  class="table">
                  <tr  class="theader">
                    <td v-for="(obj,ind) in item.box_cost" :key="ind">
                      <div v-for="(value, key, idx) in obj" :key="idx">
                        {{ key }}
                      </div>
                    </td>
                  </tr>
                  <tr  class="tbody" >
                    <td v-for="(obj,ind) in item.box_cost" :key="ind">
                      <div v-for="(value, key, idx) in obj" :key="idx">
                        USD {{value}}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <!-- <div class="tab-tit renminbi">人民币港杂费</div>
            <table v-if="other_cost.length>0"  class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody" v-for="(item,index) in other_cost" :key="index">
                    <td  class="first">{{item.surcharge_title}}</td>
                    <td>{{item.cost_unit == 1 ? '箱' : '票' }}</td>
                    <td  colspan="2" v-if="item.cost_unit == 2">CNY {{item.vote_cost}}</td>
                    <td class="xiaotab" v-if="item.cost_unit == 1">

                        <table  class="table">
                        <tr  class="theader">
                            <td v-for="(obj,ind) in item.box_cost" :key="ind">
                            <div v-for="(value, key, idx) in obj" :key="idx">
                                {{ key }}
                            </div>
                            </td>
                        </tr>
                        <tr  class="tbody" >
                            <td v-for="(obj,ind) in item.box_cost" :key="ind">
                            <div v-for="(value, key, idx) in obj" :key="idx">
                              CNY {{value}}
                            </div>
                            </td>
                        </tr>
                        </table>
                    </td>
                </tr>
            </table>
            <table v-if="other_cost.length==0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody zanweu">
                    <td class="zanwu" colspan="3">暂无数据</td>
                </tr>
            </table> -->
        </div>
        
        <div class="drawer__footer">
          <el-button class="quxiao" @click="table = false">取 消</el-button>
          <el-button class="dingcanggg" @click="table = false">去订舱</el-button>
        </div>
      </el-drawer>

      <!-- 协议 -->
      <el-dialog
        :title="ratetitle"
        :visible.sync="dialogVisiblexieyi"
        width="30%">
        <!-- <span>{{ratetext}}</span> -->
        <div v-html="ratetext"></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblexieyi = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisiblexieyi = false">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>
     
  <script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import { shippingDetail,Linefee,indexPolicy,cherryPickOrder, dict,userTemplateValidList,userTemplateDetail,getBaseEmailsByPolId,getHistorySftInfoList,getHistoryLinkmanInfoList  } from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      inputList: [{ text: "" }],
      emailList: [{ email: "" }],
      // 上传文件列表
      fujianFileList: [],
      weituoshuFileList: [],
      // 表单数据
      form: {
        type:'',
        pol_id:'',
        pod_id:'',
        is_transit:'',
        etd:'',
        eta:'',
        shipping_date:'',
        shipping_company:'',
        routeCd:'',
        other_cost:[],
        sales_code:'',//客服
        shipping_space_id: '', // 舱位id
        template_name: "", // 模板名称
        packing_unit: "", // 包装单位
        quantity: "", // 件数
        totle_weight: "", // 总货重（kgs）
        totle_volume: "", // 体积（cbm）
        describe: "", // 货物描述
        shipping_mark: "", // 唛头
        linkman: "", // 订舱联系人
        linkman_phone: "", // 订舱联系人电话
        shipper_mawb: "", // 发货人信息
        consignee_mawb: "", // 收货人信息
        notifier_mawb: "", // 通知人信息
        order_remarks: "", // 备注
        hs: [], // HS海关编码，如：["编码一","编码二"]
        boxtype: [], // 箱型箱量，如：[{"box_type":"箱型，如：20GP","number":"数量"}]
        // 箱型箱量信息，
        // 格式：[{"box_type":"箱型，如：20GP","number":"数量","money":"金额，单位美元-USD","dead_freight":"亏舱费，单位人民币-CNY","box_no":"箱号封号"}]
        email: [], // 订舱联系人邮箱，如：["邮箱一","邮箱二"]
        files: [
          // {type:1,file_name:'',file_url:'',file_type:''},
          // {type:2,file_name:'',file_url:'',file_type:''},
        ], // 附件，如：[{"type":"文件类型：1订单附件、2订单委托书","file_name":"文件名称","file_url":"文件地址","file_type":"文件类型：image、pdf、word等"}]
        pay_method:'1', //1预付、2到付
      },
      headers: {
        token: localStorage.getItem("token"),
      },
      // 包装单位列表
      packingList: [],
      // 接收参数，
      canshu: {},
       // 模版弹窗是否出现
       dialogTableVisible:false,
      //  常用收发通
       dialogShoufatong:false,
       gridDataSoufatong: [],
       soufatongRadio:'',
       //  常用订舱联系人
       dialogLianxiren:false,
       gridDataLianxiren: [],
       lianxirenRadio:'',
      //  客服代码
      baseEmailsList: [],
      // 弹窗表格展示的模版列表
      gridData: [],
      // 选中模版
      mobanRadio:'',
      // 价格明细抽屉是否打开
      table: false,
      // tableData:[]
      transformedData:[],
      // 模版列表展开行 id
      expandKeyId:undefined,
      // 模版表单
      templateForm:{},
      priceList:[],
      other_cost:[],
      // 价钱
      // 箱型费用
      boxPrice:0,
      // 箱型亏舱费
      boxPriceDead:0,
      // 箱型超重费
      boxPriceOver:0,
      haiyunPrice:0,
      // 海运附加费
      otherPrice:0,

      boxList:[
          {
              box_type:'',
              price:'',
              dead_freight:'',
              dead_freight_name:'',
              weight:'',
              box_no:'',
              overweight:'',
              weight_limit:[],
          }
      ],
      dialogVisiblexieyi:false,
      ratetitle:'',
      ratetext:'',
      chaozhong:0,
      // 线路费用  服务费
      linefee:0,
      linefeeTotal:0,
    };
  },
  methods: {
    // 富文本处理
    showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
    // 《会员服务协议》
    async getindexPolicy(){
      try {
        const res = await indexPolicy({type:'service'});
        // const res = await axios.get('https://serve.dhcang.com/api/index/policy?type=service')
        this.ratetitle = this.showHtml(res.data.title);
        this.ratetext = this.showHtml(res.data.content);
      } catch (error) {
        console.log(error, "获取平台协议失败");
      }
    },
    xieyi(){
      this.dialogVisiblexieyi = true
      this.getindexPolicy()
    },
    // 复制舱位号
    getCopy(e){
      if (navigator.clipboard && window.isSecureContext) {
        this.$message.success('复制成功')
        return navigator.clipboard.writeText(e)
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = e
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand('copy');
        if(successful){
          this.$message.success('复制成功')
          textarea.remove()
        }else{
          this.$message.success('复制失败')
          textarea.remove()
        }
      }
    },
    addRow() {
      this.inputList.push({ text: "" }); // 添加新行
    },
    removeRow(index) {
      if(this.inputList.length==1){
        this.$message({
          type:'error',
          message:'最少要填写一个'
        })
      }else{
        this.inputList.splice(index, 1); // 删除指定行
      }
    },
    addBox() {
        this.boxList.push(
            {
                box_type:'',
                price:'',
                dead_freight:'',
                dead_freight_name:'',
                weight:'',
                box_no:'',
                overweight:'',
                weight_limit:[],
            }
        ); // 添加箱型
    },
    removeBox(index) {
        if(this.boxList.length==1){
            this.$message({
                type:'error',
                message:'最少要填写一个'
            })
            return
        }
        this.boxList.splice(index, 1); // 删除箱型
        this.changeBoxPrice()
        this.changeBoxtotleweight()
    },
    changeBox(index){
      const item = this.canshu.basic_freight.findIndex(item => item.box_type == this.boxList[index].box_type)
      this.boxList[index].price = this.canshu.basic_freight[item].price
      this.boxList[index].dead_freight = this.canshu.basic_freight[item].dead_freight
      this.boxList[index].dead_freight_name = this.canshu.basic_freight[item].dead_freight_name
      this.boxList[index].overweight = this.canshu.basic_freight[item].overweight
      this.boxList[index].weight_limit = this.canshu.basic_freight[item].weight_limit

      if(this.boxList[index].weight != ''){
        if(this.canshu.basic_freight[item].overweight==1){
          const weight = this.canshu.basic_freight[item].weight_limit
          if(Number(this.boxList[index].weight) > Number( weight[weight.length-1].max_weight)){
            this.boxList[index].weight = 0
            this.$message({
              type:'error',
              message:'该箱型货重已超过最大货重，请重新设置'
            })
          }
          // if(Number(this.boxList[index].weight) > Number(this.canshu.basic_freight[item].max_weight)){
          //   this.boxList[index].weight= 0
          //   this.$message({
          //     type:'error',
          //     message:'该箱型货重已超过最大货重，请重新设置'
          //   })
          // }
        }
      }
      this.changeBoxPrice()
      this.changeBoxtotleweight()
    },
    addEmail() {
      this.emailList.push({ email: "" }); // 添加新行
    },
    removeEmail(index) {
      if(this.emailList.length==1){
        this.$message({
          type:'error',
          message:'最少要填写一个'
        })
      }else{
        this.emailList.splice(index, 1); // 删除指定行
      }
    },
    // 文件上传
    fujianSuccess(res) {
      if (this.fujianFileList.length == 10) {
        this.fujianFileList.splice(0, 1);
      }
      this.fujianFileList.push({
        type: 1,
        file_name: res.data.name,
        file_url: res.data.url,
        file_type: res.data.type,
        file_uri: res.data.uri,
      });
    },
    fujianRemove(index) {
      this.fujianFileList.splice(index, 1);
    },
    weituoshuSuccess(res) {
      if (this.weituoshuFileList.length == 1) {
        this.weituoshuFileList.splice(0, 1);
      }
      // this.weituoshuFileList.push(res.data)
      this.weituoshuFileList.push({
        type: 2,
        file_name: res.data.name,
        file_url: res.data.url,
        file_type: res.data.type,
        file_uri: res.data.uri,
      });
    },
    weituoshuRemove(index) {
      this.weituoshuFileList.splice(index, 1);
    },
    // 提交
    async submit() {
      for (let i = 0; i < this.boxList.length; i++) {
        if(this.boxList[i].box_type==''){
          this.$message({
            type:'error',
            message:'请选择箱型'
          })

          return
        }
      }
      this.form.hs = [];
      for (let i = 0; i < this.inputList.length; i++) {
        this.form.hs.push(this.inputList[i].text);
      }

      this.form.email = [];
      for (let i = 0; i < this.emailList.length; i++) {
        this.form.email.push(this.emailList[i].email);
      }

      this.form.files = [];
      // 订单附件
      for (let i = 0; i < this.fujianFileList.length; i++) {
        this.form.files.push({
          type: 1,
          file_name: this.fujianFileList[i].file_name,
          file_url: this.fujianFileList[i].file_url,
          file_uri: this.fujianFileList[i].file_uri,
          file_type: this.fujianFileList[i].file_type,
        });
      }
      // 委托书
      for (let i = 0; i < this.weituoshuFileList.length; i++) {
        this.form.files.push({
          type: 2,
          file_name: this.weituoshuFileList[i].file_name,
          file_url: this.weituoshuFileList[i].file_url,
          file_type: this.weituoshuFileList[i].file_type,
          file_uri: this.fujianFileList[i].file_uri,
        });
      }
      this.form.shipping_space_id = this.canshu.shipping_space_id
      // this.form.boxtype = this.canshu.basic_freight
      this.form.boxtype = this.boxList

      try {
          const res = await cherryPickOrder(this.form, this.headers);
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            sessionStorage.removeItem('parameter')
            this.$router.push("/Order");
          } else if (res.code == 4) {
            // 余额不足  去充值
            this.$confirm('当前账户余额不足, 请及时充值。', '提示', {confirmButtonText: '去充值',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              sessionStorage.removeItem('parameter')
              this.$router.push("/Recharge");
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });

          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 获取包装单位
    async getPacking() {
      try {
        const res = await dict(
          {
            type: "packing_unit",
          },
          this.headers
        );
        if (res.code == 1) {
          this.packingList = res.data.packing_unit;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 获取线路费用服务费
    async getLinefee() {
      try {
        const res = await Linefee({
          pod_id:this.canshu.pod_id
        },this.headers);
        if (res.code == 1) {
          this.linefee = Number(res.data.linefee);
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 收发通
    async getShoudatong() {
      this.dialogShoufatong = true;
      
      try {
        const res = await getHistorySftInfoList(this.headers);
        if (res.code == 1) {
          this.gridDataSoufatong = res.data;
          for (let i = 0; i < this.gridDataSoufatong.length; i++) {
            this.gridDataSoufatong[i].id = i
          }
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 订舱联系人
    async getLianxiren() {
      this.dialogLianxiren = true;
      
      try {
        const res = await getHistoryLinkmanInfoList(this.headers);
        if (res.code == 1) {
          this.gridDataLianxiren = res.data;
          for (let i = 0; i < this.gridDataLianxiren.length; i++) {
            this.gridDataLianxiren[i].id = i
          }
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    useShoufatong(){
      this.dialogShoufatong = false
      let data = this.gridDataSoufatong[this.soufatongRadio-1]
      this.form.shipper_mawb = data.shipper
      this.form.consignee_mawb = data.consignee
      this.form.notifier_mawb = data.notifier
      // this.soufatongRadio = ''
    },
    useLianxiren(){
      this.dialogLianxiren = false 
      this.emailList = []
      let data = this.gridDataLianxiren[this.lianxirenRadio-1]
      this.form.linkman = data.linkman
      this.form.linkman_phone = data.linkman_phone

      for (let i = 0; i < data.linkman_email.length; i++) {
        this.emailList.push({
          email:data.linkman_email[i]
        })
      }
      // this.lianxirenRadio = ''
    },
    // 模版列表
    async getTemplate() {
      this.dialogTableVisible = true;
      let form = {
        page_no: "1",
        page_size: "10",
        type:1,
      };
      try {
        const res = await userTemplateValidList(form, this.headers);
        if (res.code == 1) {
          this.gridData = res.data.lists;
          this.total = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 模版列表展开数据
    expandChange(row, expandedRows) {
      if (expandedRows.length == 1) {
        if (!this.expandKeyId) {
          this.expandKeyId = row.id;
        }
        this.getTemplateDetail(this.expandKeyId) // 获取详情接口
      } else if (expandedRows.length >= 2) {
        //已经展开一行
        this.expandKeyId = expandedRows[expandedRows.length - 1].id; //获取最后一个点开的rowID
        this.getTemplateDetail(this.expandKeyId)
        //遍历表格数据，关闭其他的展开行
        this.gridData.map(item => {
          if (item.id != this.expandKeyId) {
            this.$refs.table.toggleRowExpansion(item, false);
          }
        })
      } else {
        //关闭
        this.expandKeyId = undefined;
        this.expandData = [];
      }
    },
    // 获取模版详情
    async getTemplateDetail(e){
      try {
        const res = await userTemplateDetail({
          id:e
        },this.headers)
        if (res.code==1) {
          this.templateForm=res.data
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 获取客服代码
    async getBaseEmails(){
      try {
        const res = await getBaseEmailsByPolId({
          prot_id:this.canshu.pol_id
        },this.headers)
        if (res.code==1) {
          this.baseEmailsList=res.data
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 使用模版
    async useTemplate(){
      try {
        const res = await userTemplateDetail({
          id:this.mobanRadio
        },this.headers)
        if (res.code==1) {
          this.boxPrice = 0
          this.form.hs = res.data.hs
          this.form.email=res.data.email
          this.form.split_order_address=res.data.split_order_address
          this.form.packing_unit=res.data.packing_unit
          this.form.quantity=res.data.quantity
          this.form.totle_weight=res.data.totle_weight
          this.form.totle_volume=res.data.totle_volume
          this.form.describe=res.data.describe
          this.form.shipping_mark=res.data.shipping_mark
          this.form.linkman=res.data.linkman
          this.form.linkman_phone=res.data.linkman_phone
          this.form.shipper_mawb=res.data.shipper
          this.form.consignee_mawb=res.data.consignee
          this.form.notifier_mawb=res.data.notifier
          this.form.order_remarks=res.dataNaNpxarks
          this.form.files=res.data.files

          this.boxList = []
          for (let i = 0; i < res.data.boxtype.length; i++) {
            for (let j = 0; j < this.canshu.basic_freight.length; j++) {
              if(res.data.boxtype[i].box_type == this.canshu.basic_freight[j].box_type){
                this.boxList.push({
                  box_type:res.data.boxtype[i].box_type,
                  price:this.canshu.basic_freight[j].price,
                  dead_freight:this.canshu.basic_freight[j].dead_freight,
                  dead_freight_name:this.canshu.basic_freight[j].dead_freight_name,
                  weight:res.data.boxtype[i].weight,
                  box_no:'',
                  overweight:this.canshu.basic_freight[j].overweight,
                  weight_limit:this.canshu.basic_freight[j].weight_limit,
                })
              }  
            }  
          }

          this.changeBoxPrice()

          this.emailList=[]
          for (let i = 0; i < res.data.email.length; i++) {
              this.emailList.push({'email':res.data.email[i]})
          }

          this.inputList=[]
          for (let i = 0; i < res.data.hs.length; i++) {
              this.inputList.push({'text':res.data.hs[i]})
          }


          this.fujianFileList = res.data.files
          // this.weituoshuFileList = []
          // for (let i = 0; i < res.data.files.length; i++) {
          //     if(res.data.files[i].type==1){
          //       this.fujianFileList.push(res.data.files[i])
          //     }

          //     if(res.data.files[i].type==2){
          //       this.weituoshuFileList.push(res.data.files[i])
          //     }
          // }

          this.dialogTableVisible = false
          this.mobanRadio = ''
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 文件下载
    download(e) {
        const link = document.createElement('a');
        link.href = e.file_uri;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
        document.bodyNaNpxoveChild(link);
    },
    // 总价格
    changeBoxPrice(){
      this.boxPrice = 0
      this.boxPriceDead = 0
      this.boxPriceOver = 0
      // this.linefeeTotal = Number(this.linefee)*this.boxList.length
      let bboxLIST = []
      for (let i = 0; i < this.boxList.length; i++) {
        bboxLIST.push(this.boxList[i].box_type)
        this.boxPrice += Number(this.boxList[i].price)  //箱型价格
        this.boxPriceDead += Number(this.boxList[i].dead_freight)  // 亏舱费
        if(this.boxList[i].weight!=''){  //超重费
          if(this.boxList[i].overweight==1){ //超重
            // 循环判断  箱重在那个范围内  加不同的价格
            // if(Number(this.boxList[i].weight)>Number(this.boxList[i].min_weight)){
            //   this.boxPriceOver += Number(this.boxList[i].overweight_fees)
            //   this.chaozhong = 1
            // }

            let weight_limit = this.boxList[i].weight_limit
            for (let j = 0; j < weight_limit.length; j++) {
              if(Number(this.boxList[i].weight)>Number(weight_limit[j].min_weight) && Number(this.boxList[i].weight)<=Number(weight_limit[j].max_weight)){
                this.boxPriceOver += Number(weight_limit[j].overweight_fees)
                this.chaozhong = 1
              }
            }
            
          }
        }
      }

      this.haiyunPrice = 0
      for (let i = 0; i < this.priceList.length; i++) {
        if(this.priceList[i].cost_unit==1){
          // 箱
          this.priceList[i].box_cost.forEach(obj => {
            Object.keys(obj).forEach(key => {
              if(bboxLIST.includes(key)){
                this.haiyunPrice += Number(obj[key])
              }
            });
          });
        } else if(this.priceList[i].cost_unit==2){
          // 票
          // vote_cost
          this.haiyunPrice += Number(this.priceList[i].vote_cost)
        }   
      }

      this.otherPrice = 0
      for (let i = 0; i < this.other_cost.length; i++) {
        if(this.other_cost[i].cost_unit==1){
          // 箱
          this.other_cost[i].box_cost.forEach(obj => {
            Object.keys(obj).forEach(key => {
              if(bboxLIST.includes(key)){
                this.otherPrice += Number(obj[key])
              }
            });
          });
        } else if(this.other_cost[i].cost_unit==2){
          // 票
          // vote_cost
          this.otherPrice += Number(this.other_cost[i].vote_cost)
        }   
      }

    },
    // 总货重
    changeBoxtotleweight(){
      // this.boxPrice += Number(e.price)
      this.form.totle_weight = 0
      for (let i = 0; i < this.boxList.length; i++) {
        this.form.totle_weight += Number(this.boxList[i].weight)
      }
    },
    // 校验邮箱
    validEmsil(e) {
      let emial = e.target.value
      if(emial==''){
        return
      }
      if (emial == "" || emial == undefined) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          emial
        )
      ) {
        this.$message({
          // duration:0,
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 校验手机号
    validDianhua() {
      let dianhua = this.form.linkman_phone
      if(dianhua==''){
        return
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 改变箱重
    changeBoxWeight(index){
      if(this.boxList[index].box_type == ''){
        return
      }
      const item = this.canshu.basic_freight.findIndex(item => item.box_type == this.boxList[index].box_type)

      if(this.canshu.basic_freight[item].overweight==0){
        this.changeBoxtotleweight()
        return
      }
      const weight = this.canshu.basic_freight[item].weight_limit
      if(Number(this.boxList[index].weight) > Number( weight[weight.length-1].max_weight)){
        this.boxList[index].weight = 0
        this.$message({
          type:'error',
          message:'该箱型货重已超过最大货重，请重新设置'
        })
      }
      this.changeBoxPrice()
      this.changeBoxtotleweight()
    },
    // 输入的数字大于0
    onBlur(e){
      // if(e.target.value<0){
      if(e.target.value == ''){
        return
      }
      if(!/\d$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为数字'
        })
        return
      }
    },
    hsBlus(e){
      if(e.target.value == ''){
          return
        }
      if(!/^[1-9]\d{5}$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为六位数字'
        })
      }
    },
    async getShipDetail(){
      const res = await shippingDetail({
        shipping_space_id:this.$route.params.shipping_space_id
      },this.headers)

      if(res.code==1){
        this.boxPrice=0
        this.canshu = res.data
        this.priceList = this.canshu.surcharge
        this.other_cost = this.canshu.other_cost

        this.canshu.shipping_companyLogo = this.canshu.shipping_company.logo
        this.canshu.supplier_infoSn = this.canshu.supplier_info.sn
        this.form.sales_code = this.canshu.kefu_info.sales_code
        this.form.type = this.canshu.type
        this.form.pol_id = this.canshu.pol_id
        this.form.pod_id = this.canshu.pod_id
        this.form.is_transit = this.canshu.is_transit
        this.form.etd = this.canshu.etd
        this.form.eta = this.canshu.eta
        this.form.shipping_date = this.canshu.shipping_date
        this.form.shipping_company = this.canshu.shipping_company
        this.form.other_cost = this.canshu.other_cost
        this.form.routeCd = this.canshu.routeCd


      // this.getLinefee();
      this.getBaseEmails()
      }else{
        this.$message({
          type:'error',
          msg:'获取舱位详情失败'
        })
      }
    }
  },
  mounted() {
    if(this.$route.params.shipping_space != undefined && this.$route.params.shipping_space != null && this.$route.params.shipping_space_id != false){
      this.getShipDetail() //获取舱位详情
    }else{
      this.boxPrice=0
      this.canshu = JSON.parse(sessionStorage.getItem('parameter'));
      this.priceList = this.canshu.surcharge
      this.other_cost = this.canshu.other_cost
      this.canshu.shipping_companyLogo = this.canshu.shipping_company.logo
      this.canshu.supplier_infoSn = this.canshu.supplier_info.sn
      this.form.sales_code = this.canshu.kefu_info.sales_code
      this.form.type = this.canshu.type
      this.form.pol_id = this.canshu.pol_id
      this.form.pod_id = this.canshu.pod_id
      this.form.is_transit = this.canshu.is_transit
      this.form.etd = this.canshu.etd
      this.form.eta = this.canshu.eta
      this.form.shipping_date = this.canshu.shipping_date
      this.form.shipping_company = this.canshu.shipping_company
      this.form.other_cost = this.canshu.other_cost
      this.form.routeCd = this.canshu.routeCd

      
      // this.getLinefee();
      this.getBaseEmails()
    }
    
    this.getPacking();
  },
};
</script>
  
  <style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  // background: #Fff;
}

.Booking {
  background: #f9f9f9;
}

.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.template {
  height: 122px;
  // background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #606260;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .shiyopng {
      color: #0073f5;
      font-size: 20px;
      margin-bottom: 8px;

      .wode {
        margin-left: 9px;
        display: inline-block;
        width: 80px;
        height: 28px;
        background: #edf6ff;
        border-radius: 4px 4px 4px 4px;

        font-size: 14px;

        text-align: center;
        line-height: 28px;
      }
    }
  }

  .right {
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    cursor: pointer;
  }
}

.template {
  box-sizing: border-box;
  height: 122px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #606260;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .shiyopng {
      color: #0073f5;
      font-size: 20px;
      margin-bottom: 8px;

      .wode {
        margin-left: 9px;
        display: inline-block;
        width: 80px;
        height: 28px;
        background: #edf6ff;
        border-radius: 4px 4px 4px 4px;

        font-size: 14px;

        text-align: center;
        line-height: 28px;
      }
    }
  }

  .right {
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    cursor: pointer;
  }
}

.info {
  box-sizing: border-box;
  // height: 297px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;

  padding: 32px 32px 24px 32px;

  margin-bottom: 20px;
  color: #606260;
}
.shang {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 164px;
  border-bottom: #eee solid 1px;
  .logo {
    width: 48px;
    // height: 48px;
    margin-right: 120px;
    img{
      width: 65px;

    }
  }
  .qiyun {
    // width: 120px;
    .date {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin-bottom: 4px;
    }
    .address {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      font-style: normal;
      text-transform: none;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dao {
    width: 100px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #999999;
    font-style: normal;
    text-transform: none;

    margin: 0 48px;
    img {
      width: 100px;
      height: 7px;
    }
    div {
      height: 12px;
    }
  }
}
.jiacu{
  font-weight: bold;
}
.youbian{
  margin-right: 3rem;
}
.xiaxia{
  margin-top: .75rem;
  .copy{
    color: #0073f5;
    cursor: pointer;
  }
}
.zhong {
  display: flex;

  margin-top: .75rem;
  margin-bottom: 12px;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #606260;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  div {
    margin-right: 48px;
  }
  .kuan {
    width: 8.125rem;
  }
}

.xia {
  display: flex;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #606260;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  .kuan {
    width: 8.125rem;
    margin-right: 48px;

    display: flex;
  }

  .kuan:nth-child(2) {
    width: 132px;
    margin-right: 42px;
  }
  .cilick {
    cursor: pointer;
    color: #0073f5;
  }
}

.customs {
  // height: 217px;
  background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;

  .title {
    width: 109px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
    margin-top: 12px;
  }

  .form-tit {
    // width: 92px;
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    font-style: normal;
    text-transform: none;

    margin-top: 24px;
    margin-bottom: 12px;

    span {
      color: #fe3300;
    }
  }

  .input {
    display: flex;
    flex-wrap: wrap;
    .yi {
      display: flex;
      align-items: center;
      margin-right: 24px;
      margin-bottom: 20px;
    }

    .yi2 {
      display: flex;
      align-items: center;
      margin-right: 24px;
      margin-right: 0px;
      margin-bottom: 20px;
    }

    :deep(.el-input) {
      width: 242px;
      input {
        width: 242px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }

    .el-icon-delete {
      color: #606260;
      margin-left: 8px;
      cursor: pointer;

      font-size: 16px;
    }

    
  }

  .add {
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    width: 7.5rem;

    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
      font-size: 16px;
    }
  }
}

.boxType {
  // height: 218px;
  background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;
  .title {
    // width: 156px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    // margin-top: 32px;

    display: flex;
    margin-bottom: 24px;
  }

  .cilick{
    cursor: pointer;
    color: #0073f5;
    margin-left: 1rem;
    font-size: .875rem;
  }

  .boxNum {
    margin-top: 24px;

    display: flex;
    .box-yi {
      margin-right: 24px;
      .box-tit {
        margin-bottom: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        font-style: normal;
        text-transform: none;
        color: #606260;
        span {
          color: #fe3300;
        }
      }

      .el-input-number {
        width: 242px;
        height: 44px;
      }

      .qian {
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #606260;
        font-style: normal;
        text-transform: none;

        display: flex;
        div {
          margin-right: 16px;
        }
      }
    }
  }

  .add{
    margin-top: 24px;
    color: #0073F5;
    font-size: .875rem;
    cursor: pointer;
    width: 7.5rem;
    display: flex;
    align-items: center;
    i{
      margin-right: 4px;
      font-size: 1rem;
    }
  }

  .el-icon-delete{
    margin-left: .5rem;
    color: #606260;
  }
}

.CargoInformation {
  // height: 401px;
  background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;

  .title {
    // width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    // margin-top: 32px;
  }

  .info-shang {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    .word {
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-style: normal;
      text-transform: none;
      color: #606260;
      span {
        color: #fe3300;
      }
    }
    :deep(.el-input) {
      input {
        width: 266px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 556px;
        height: 160px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
  }

  .info-shoufat {
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 362px;
      }
    }
  }
}

.shoufat {
  :deep(.el-textarea) {
    .el-textarea__inner {
      width: 362px;
    }
  }
}

.phone-info {
  height: 100%;
  .info-shang {
    flex-wrap: wrap;
    justify-content: start;

    .yi1 {
      margin-right: 24px;
    }
    .yi {
      margin-bottom: 20px;
      margin-right: 24px;

      :deep(.el-input) {
        width: 226px;
        input {
          width: 226px;
          height: 44px;
          background: #f9f9f9;
          border-radius: 8px 8px 8px 8px;
          border: 0;
        }
      }
    }
    .yi2 {
      margin-right: 0px;
    }
    .delete {
      margin-right: 4px;
      font-size: 16px;

      cursor: pointer;

      font-size: 14px;
      color: #fe3300;

      line-height: 44px;
    }

    .ipt_del {
      display: flex;
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
    }
  }
  .add {
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    width: 7.5rem;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
  }

  .info_phone {
    .word {
      margin-top: 24px;
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 1136px;
      }
    }
  }
}

.update {
  .title {
    margin-top: 24px;
    margin-bottom: 24px;
    margin-top: 32px;
  }
  .shangchuan {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }

  .btn {
    display: flex;
    margin-top: 12px;
    .sc_btn {
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      color: #0073f5;
      font-size: 14px;
      border: 0;
    }
  }

  .upload-demo {
    width: 266px;
    margin-right: 24px;
  }

  .updateList {
    // margin-top: 12px;

    display: flex;
    align-items: baseline;

    i {
      font-size: 16px;
      color: #00b53c;
      margin-right: 9px;
    }

    .name {
      width: 130px;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;
    }

    .el-butnm {
      color: #fe3300;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      font-style: normal;
      text-transform: none;

      height: 24px;
    }

    .del {
      color: #0073f5;
      margin-left: 53px;
    }
  }
}

.button {
  text-align: center;
  margin-top: 48px;
  .quxiao {
    width: 100px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    border: 0;
    color: #999999;
    font-size: 14px;
    margin-right: 16px;
  }

  .dingcanggg {
    width: 100px;
    height: 40px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    border: 0;
    font-size: 14px;
    margin-right: 32px;
  }
}

.fukuan{
  // width: 1920px;
  height: 118px;
  background: #FFFFFF;

  .fk-content{
    height: 118px;

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .fk-left{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #606260;
      line-height: 14px;
      font-style: normal;
      text-transform: none;
      .yi{
        .spn{
          font-size: 14px;
          color: #333333;
        }
      }

      .er{
        margin: 8px 0;

        span{
          color: #0073F5;

          cursor: pointer;
        }
      }
    }

    .fk-right{
      display: flex;
      .zongqian{
        // display: inline-block;
        display: flex;
        align-items: flex-end;
        flex-direction: column;

        .qianmingcheng{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: .875rem;
          color: #606260;
          line-height: 1rem;
          font-style: normal;
          text-transform: none;
        }
      }
      .zong{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #FE3300;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .mingxi{
        width: 100px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #0073F5;
        color: #0073F5;
        background: #fff;

        margin-left: 24px;
        margin-right: 16px;
      }

      .tijiao{
        width: 100px;
        height: 40px;
        background: #0073F5;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        border: 0;
      }
    }
  }
}

.el-drawer{
  .drawer-title{
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span{
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    i{
      font-size: 28px;
      color: #999;
      cursor: pointer;
    }
  }
  .tab-det{
    padding: 32px 32px 0 32px;
  }

  .tab-tit{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }

  .table{
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    td{
      padding-left: 24px;
    }
    .theader{
      height: 48px;
      background: #F9F9F9;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      
    }
    .first{
      padding-left: 24px;
      width: 320px;
    }
    .tbody{
      height: 68px;
      background: #fff;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      font-style: normal;
      text-transform: none;
    }
    .zanweu{
      text-align: center;
    }
}

.renminbi{
  margin-top: 24px;
}

  .datab{
    margin-top: 20px;
    border: solid 1px #eee;

    .xiaotab{
      padding: 0;
    }
  }
  .drawer__footer{
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;

    .quxiao{
      width: 100px;
      height: 40px;
      background: #F9F9F9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 16px;
    }

    .dingcanggg{
      width: 100px;
      height: 40px;
      background: #0073F5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      border: 0;
      font-size: 14px;
      margin-right: 32px;
    }
  }
}

.modelDetail {
  .detail {
    margin-top: 24px;
    .de-tit {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }

    .de-con {
      display: flex;
      flex-wrap: wrap;
      .conyi {
        width: 213px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        margin-right: 17px;
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        div {
          // line-height: 40px;
          // padding-left: 12px;
          // padding-right: 12px;
          padding: 12px;
          width: 213px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .coner {
        margin-right: 0px;
      }
    }

    .de-coner {
      justify-content: space-between;
      .conyi {
        margin-right: 0px;
      }
    }

    .de-consan {
      .conyi {
        width: 446px;
        height: 140px;

        padding: 12px;

        p {
          line-height: 16px;
          margin: 0;
        }
      }
    }

    .de-consi {
      .conyi {
        width: 290px;
        height: 140px;
      }
    }

    .de-conwu {
      .conyi {
        width: 910px;
        height: 140px;
      }
    }

    .con-up {
      display: flex;
      align-items: center;
      i {
        font-size: 16px;
        color: #00b53c;
        margin-right: 9px;
      }

      .name {
        width: 130px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;
      }

      .el-butnm {
        color: #0073f5;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        font-style: normal;
        text-transform: none;

        height: 18px;
        padding: 0;
      }
    }
  }
}


// 单选按钮警告错误
::v-deep .el-radio__original {
  display: none !important;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}

.box-c,.box-con,.nei{
    display: flex;
    align-items: center;
}

.box-c{
    margin-bottom: 24px;
}

.box-con{
    // width: 36.125rem;
    height: 3rem;
    background: #F9F9F9;
    border-radius: .5rem .5rem .5rem .5rem;
    .line{
        width: .0625rem;
        height: 1.5rem;
        // background: red;
        background: #EEEEEE;
    }
    .ronmg{
        width: 200px;
        margin: 0 16px;
        :deep(.el-input){
            input{
                color: #333333;
                background: #F9F9F9;
                border-radius: .5rem .5rem .5rem .5rem;
                border: 0;
                padding: 0;
            }
        }
    }

    .nei{
        span{
            width: 40px;
            display: inline-block;
            font-size: 14px;
            margin-right: 4px;
        }
        .zhongKgs{
          width: 90px;
        }
    }
}
.el-popover {
  p {
    color: #606260;
  }
  span {
    color: #fe3300;
  }
}
</style>